<template>
  <div>
    <search class="search-wrapper" @search="searchHandle" :type="3" />
    <!--操作栏-->
    <div class="handle_wrapper">
      <butn
        class="btn-wrapper"
        v-permission="'ticketUser:export'"
        btntype="primary"
        title="导出"
        @click.native="exportPage"
      ></butn>
      <butn
        class="btn-wrapper"
        v-permission="'ticketUser:delete'"
        btntype="primary"
        title="批量移除"
        @click.native="deleteBatch"
        :disabled="!batchDeleteFlag"
      ></butn>
      <butn
        class="btn-wrapper"
        v-permission="'ticketUser:sync'"
        btntype="primary"
        title="同步干部之家"
        @click.native="handleSyncGbzj"
        :disabled="!batchDeleteFlag"
      ></butn>
    </div>
    <Table
      @selection-change="selectChange"
      :data="tableData"
      row-key="uuid"
      :type="'3'"
      @handleDetete="handleDetete"
    />
    <div class="RCPagination">
      <RCPagination
        ref="pagination"
        v-model="tableData"
        :startRequest="false"
        :api="api"
      />
    </div>
  </div>
</template>
<script>
import {
  ticketUserPage,
  hasTicketUserExport,
  ticketUserDelete,
  syncGbzj,
} from "@/api/resourceService";
import butn from "@/components/button/index";
import { ioRead } from "@/utils/common.js";
import Search from "../search";
import Table from "../table.js";
import RCPagination from "@/components/pagination/paginationManage";

export default {
  components: {
    butn,
    Search,
    Table,
    RCPagination,
  },
  props: {
    ticketId: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      api: ticketUserPage,
      tableData: [],
      dataname: {},
      checkArray: [],
    };
  },
  computed: {
    batchDeleteFlag() {
      return this.checkArray.length > 0;
    },
  },
  created() {
    //加载列表
    this.$nextTick(() => {
      this.searchHandle();
    });
  },
  methods: {
    selectChange(selections) {
      this.checkArray = selections;
    },
    searchHandle(params = {}) {
      this.dataname = {
        ...params,
        ticketId: this.ticketId,
        joinType: 1,
      };
      this.$refs["pagination"].search(this.dataname);
    },
    async confirmWay(msg) {
      let message =
        msg + "<br>" + "删除后会关联删除用户线上/线下课程参与资格。";
      const flag = await this.$confirm(message, "系统提示", {
        dangerouslyUseHTMLString: true,
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      });
      return flag !== "confirm";
    },
    // 单个删除
    async handleDetete(row) {
      if (await this.confirmWay("确认删除该用户吗？")) return;
      this.fetchDelete([row.uuid]);
    },
    // 批量删除
    async deleteBatch() {
      let params = this.checkArray.map((item) => item.uuid);
      if (await this.confirmWay("确认批量删除用户吗？")) return;
      this.fetchDelete(params);
    },
    fetchDelete(uuids = []) {
      ticketUserDelete({ uuids }).then((res) => {
        if (!res || res.code != 0) return;
        this.$message({
          message: res.msg,
          type: "success",
        });
        this.searchHandle(this.dataname);
      });
    },

    /**
     * 同步干部之家
     */
    handleSyncGbzj() {
      let uuids = this.checkArray.map((item) => item.uuid);
      syncGbzj({ uuids }).then((res) => {
        if (!res || res.code != 0) return;
        this.$message({
          message: res.msg,
          type: "success",
        });
        this.searchHandle(this.dataname);
      })
    },

    exportPage() {
      hasTicketUserExport({
        ...this.dataname,
      }).then((response) => ioRead(response));
    },
  },
};
</script>
<style lang="scss" scoped>
.search-wrapper {
  float: right;
}
.btn-wrapper {
  margin-left: 0px;
  margin-right: 10px;
  margin-bottom: 10px;
}

.content-top {
  padding-bottom: 20px;
  border-bottom: 1px solid #ececec;
  margin-bottom: 20px;
}
</style>
